var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-viewer"},_vm._l((_vm.pages),function(page,index){return _c('div',{key:index,ref:"canvasContainer",refInFor:true,staticClass:"pdf-page"},[_c('canvas',{ref:'canvas' + index,refInFor:true})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed614d86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdf/index.vue
// module id = null
// module chunks = 